// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------modal---------------- */

.ModalRaffles_boxModal__2zC1U {
  animation: ModalRaffles_init__uEdKW 0.3s;
  transition: 1s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  overflow: scroll;
  overflow-x: hidden;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 90%;
  border-radius: 5px;
  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);
}

.ModalRaffles_boxModal__2zC1U .ModalRaffles_exit__ozjTr {
  width: 90%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 30px;
  margin-top: 20px;
  margin-bottom: 40px;
}

.ModalRaffles_boxModal__2zC1U .ModalRaffles_exit__ozjTr .ModalRaffles_exitIcon__9\\+UYm {
  transition: 0.3s;
}

.ModalRaffles_boxModal__2zC1U .ModalRaffles_exit__ozjTr .ModalRaffles_exitIcon__9\\+UYm:hover {
  transition: 0.2s;
  scale: 1.3;
  cursor: pointer;
  filter: brightness(1.6);
}

.ModalRaffles_boxModal__2zC1U .ModalRaffles_titleModal__Gy41A {
  width: 95%;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: flex-start;
  margin-top: 15px;
}

.ModalRaffles_boxModal__2zC1U .ModalRaffles_titleModal__Gy41A p {
  font-size: 1.3rem;
  margin: 0;
}

.ModalRaffles_boxModal__2zC1U .ModalRaffles_titleModal__Gy41A span {
  font-size: 1rem;
  color: #5a5a5a;
  margin: 5px 0 0;
}

.ModalRaffles_boxModal__2zC1U .ModalRaffles_loader__mDBHe {
  transition: 0.5s;
  min-height: 40vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  font-weight: 300;
}

.ModalRaffles_boxModal__2zC1U .ModalRaffles_item__ArT0B {
  margin-bottom: 15px;
}

.ModalRaffles_boxModal__2zC1U .ModalRaffles_item__ArT0B p {
  margin: 0;
  margin-bottom: 5px;
  font-size: 1rem;
  font-weight: 300;
}

.ModalRaffles_boxModal__2zC1U .ModalRaffles_tableContainer__RPOpJ {
  animation: ModalRaffles_init2__g3vpa 0.3s both 0.3s;
  overflow-y: scroll;
  max-height: 100%;
  border-radius: 3px;
}

@keyframes ModalRaffles_init2__g3vpa {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes ModalRaffles_init1__Cl17P {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Pagos/Filters/ModalRaffles/ModalRaffles.module.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,wCAAoB;EACpB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mDAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["/* -----------------modal---------------- */\n\n.boxModal {\n  animation: init 0.3s;\n  transition: 1s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  position: absolute;\n  overflow: scroll;\n  overflow-x: hidden;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-height: 90%;\n  border-radius: 5px;\n  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);\n}\n\n.boxModal .exit {\n  width: 90%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 30px;\n  margin-top: 20px;\n  margin-bottom: 40px;\n}\n\n.boxModal .exit .exitIcon {\n  transition: 0.3s;\n}\n\n.boxModal .exit .exitIcon:hover {\n  transition: 0.2s;\n  scale: 1.3;\n  cursor: pointer;\n  filter: brightness(1.6);\n}\n\n.boxModal .titleModal {\n  width: 95%;\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  align-items: flex-start;\n  margin-top: 15px;\n}\n\n.boxModal .titleModal p {\n  font-size: 1.3rem;\n  margin: 0;\n}\n\n.boxModal .titleModal span {\n  font-size: 1rem;\n  color: #5a5a5a;\n  margin: 5px 0 0;\n}\n\n.boxModal .loader {\n  transition: 0.5s;\n  min-height: 40vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 2rem;\n  font-weight: 300;\n}\n\n.boxModal .item {\n  margin-bottom: 15px;\n}\n\n.boxModal .item p {\n  margin: 0;\n  margin-bottom: 5px;\n  font-size: 1rem;\n  font-weight: 300;\n}\n\n.boxModal .tableContainer {\n  animation: init2 0.3s both 0.3s;\n  overflow-y: scroll;\n  max-height: 100%;\n  border-radius: 3px;\n}\n\n@keyframes init2 {\n  0% {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes init1 {\n  0% {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxModal": `ModalRaffles_boxModal__2zC1U`,
	"init": `ModalRaffles_init__uEdKW`,
	"exit": `ModalRaffles_exit__ozjTr`,
	"exitIcon": `ModalRaffles_exitIcon__9+UYm`,
	"titleModal": `ModalRaffles_titleModal__Gy41A`,
	"loader": `ModalRaffles_loader__mDBHe`,
	"item": `ModalRaffles_item__ArT0B`,
	"tableContainer": `ModalRaffles_tableContainer__RPOpJ`,
	"init2": `ModalRaffles_init2__g3vpa`,
	"init1": `ModalRaffles_init1__Cl17P`
};
export default ___CSS_LOADER_EXPORT___;
